import { Component, OnInit } from '@angular/core';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { DataCollectionNote, DataCollectionNotePosition, DataCollectionStepByStepChecklist } from '@features/eat/models/data-collection-step-by-step-checklists.model';
import { PlatformQueryResponse } from '@shared/models/platform-query/platform-query';
import { HomeSideBarItem } from '@shared/models/platform-tool-models';
import { take } from 'rxjs';

@Component({
  selector: 'app-orbitax-connect-step-by-step-checklist',
  standalone: false,
  templateUrl: './orbitax-connect-step-by-step-checklist.component.html',
  styleUrl: './orbitax-connect-step-by-step-checklist.component.scss'
})
export class OrbitaxConnectStepByStepChecklistComponent implements OnInit {
public data?: any;
  public homeSideBarItem: HomeSideBarItem;
  protected checklistModel: DataCollectionStepByStepChecklist = new DataCollectionStepByStepChecklist();

  constructor(private platformQueryService: PlatformQueryService) {
  }

  ngOnInit(): void {
   this.getChecklists();
  }

  private getChecklists()  {
    if (this.homeSideBarItem.query) {
      return this.platformQueryService.executeQuery(this.homeSideBarItem.query).pipe(take(1)).subscribe(
        (response: PlatformQueryResponse) => {
          this.checklistModel = response.fieldValues['StepByStepChecklist'];
          if (this.checklistModel.groups.length > 0) {
            this.checklistModel.groups[0].isExpanded = true;
          }
        }
      );
    }
  }

  protected isNoteAtBottom(note: DataCollectionNote): boolean {
     return note && note.position === DataCollectionNotePosition.Bottom;
  }

  protected isNoteOnTop(note: DataCollectionNote): boolean {
    return note && note.position === DataCollectionNotePosition.Top;
  }
}
